export { default as sharedConfig } from './src/tailwind-config';
export { customTwMerge as twMerge, twJoin } from './src/utils/tailwind-merge';
export { createTailwindConfig } from './src/utils/config-factory';
